import HttpHelpers from './helpers';

const PublicListingsApiEndpoints = {
  getPublicListings: (params) => {
    return HttpHelpers.authenticatedAxios
      .get('listing', { params })
      .then((response) => response.data);
  },

  getListingDetails: (id, params) => {
    return HttpHelpers.authenticatedAxios
      .get(`listing/${id}`, { params })
      .then((response) => response.data);
  },

  getListingAvailability: (listingId, entityId, date) => {
    return HttpHelpers.authenticatedAxios
      .get(`/listing/${listingId}/entity/${entityId}/available-hours/${date}`)
      .then((response) => response.data);
  },

  estimateBookingCalculations: (listingId, data) => {
    return HttpHelpers.authenticatedAxios
      .post(`/listing/${listingId}/calculate-booking`, data)
      .then((response) => response.data);
  },
  getListingReviews: (id, params) => {
    return HttpHelpers.authenticatedAxios
      .get(`/listing/${id}/review`, { params })
      .then((response) => response.data);
  },
};

export default PublicListingsApiEndpoints;
